export default __webpack_public_path__ + "static/media/ferry-shuttle.5cfcbf6a.svg";